
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router/composables'
import VMicroFrontProvider from '@b2ag/micro-front-tools/src/components/VMicroFrontProvider.vue'

export default defineComponent({
  name: 'VProductMicro',
  components: { VMicroFrontProvider },
  setup() {
    const route = useRoute()

    const productId = computed(() => route.params.productId)

    return { productId }
  },
})
